import { render, staticRenderFns } from "./providerFromUser.vue?vue&type=template&id=5a9a1c44&scoped=true"
import script from "./providerFromUser.vue?vue&type=script&lang=js"
export * from "./providerFromUser.vue?vue&type=script&lang=js"
import style0 from "./providerFromUser.vue?vue&type=style&index=0&id=5a9a1c44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9a1c44",
  null
  
)

export default component.exports